let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1uh4z")).then(() => parcelRequire('3g0Pk'));